import ReactDOM from 'react-dom';
import React, { useEffect, useState } from "react";
import "./GuideModal.css";

const GuideModal = ({ isOpen, onClose, initialImageIndex }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(initialImageIndex);

  useEffect(() => {
    if(isOpen) {
        setCurrentImageIndex(initialImageIndex);
    }
  }, [isOpen, initialImageIndex]);

  const images = [
    "/guide1.png",
    "/guide2.png",
    "/guide3.png",
    "/guide4.png",
    "/guide5.png",
  ];

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="guide-modal-overlay">
      <div className="guide-modal-content">
        <button className="close-button" onClick={onClose}>
          X
        </button>
        <div className="몇번째이미지인지">
          <div className={`n번째 ${currentImageIndex === 0 ? 'n번째active' : ''}`}>-</div>
          <div className={`n번째 ${currentImageIndex === 1 ? 'n번째active' : ''}`}>-</div>
          <div className={`n번째 ${currentImageIndex === 2 ? 'n번째active' : ''}`}>-</div>
          <div className={`n번째 ${currentImageIndex === 3 ? 'n번째active' : ''}`}>-</div>
          <div className={`n번째 ${currentImageIndex === 4 ? 'n번째active' : ''}`}>-</div>
        </div>
        <img src={images[currentImageIndex]} alt="Guide" className="guide-image" />
        <div className="navigation-buttons">
          <button className="prev-button" onClick={handlePrev}>
            &lt;
          </button>
          <button className="next-button" onClick={handleNext}>
            &gt;
          </button>
        </div>
      </div>
    </div>,
    document.getElementById('root')
  );
};

export default GuideModal;
